// Product page (sections/product.liquid): variant picker over both twins (normal and "-differenzbesteuert"),
// price, photo swap, delivery date, energy label / data sheet dialog, floating buy bar, fly-to-cart.
// Picker rules from the old theme: only available variants are offered; for the same combination the cheaper
// twin wins; a value with no match for the current combination is listed under "other combinations" and jumps
// to the cheapest available variant with it. Changing the variant never reloads the page.

const root = document.querySelector('[data-product]')
const json = document.querySelector('[data-product-json]')
if (root && json) init(root, JSON.parse(json.textContent))

function init(root, data) {
  const html = document.documentElement
  const reduced = html.classList.contains('reduced')
  const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)'
  const variants = data.variants.filter(Boolean)
  // cheapest first ("the cheaper twin wins"); prices from 9,000 € are placeholders in the shop data, even when available
  const avail = variants.filter((v) => v.a && v.p < 900000).sort((a, b) => a.p - b.p)
  const condIdx = data.options.findIndex((o) => /zustand/i.test(o))
  const colorIdx = data.options.findIndex((o) => /farbe|colou?r/i.test(o))
  const same = (a, b) => a.every((x, i) => x === b[i])
  const pick = (opts) => avail.find((v) => same(v.o, opts))
  const money = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c])

  // Start: the variant from the URL / server, but if its twin offers the same combination cheaper, that one.
  let cur = avail.find((v) => v.id === data.current) || avail[0]
  if (!cur) return // sold out: nothing to pick
  cur = pick(cur.o) || cur

  const form = root.querySelector('[data-product-form]')
  const idInput = root.querySelector('[data-variant-id]')
  const stageImg = root.querySelector('.pdp__img img')
  const blob = root.querySelector('.pdp__blob')
  const bar = document.querySelector('[data-buybar]')
  if (bar) document.body.append(bar) // out of #MainContent's stacking context, so the footer can't cover it
  const barImg = bar?.querySelector('.buybar__thumb img')

  // ---------- Price, in the same markup as snippets/price.liquid ----------
  const priceHtml = (v) => {
    const [a, b] = money(v.p).split(',')
    const ref = v.c > v.p
      ? `<span class="price__ref"><s>${money(v.c)}</s> ${esc(data.labels.ref_new)}<button class="price__info" type="button" popovertarget="RefPrice" aria-label="${esc(data.labels.ref_label)}">i</button></span>`
      : ''
    return `<span class="price"><span class="price__now">${a}<small>,${b}</small></span>${ref}</span>`
  }

  // The price counts to the new value (like the prototype), main price and buy-bar/button prices together.
  let shown = cur.p, tick = 0
  const countPrice = (v) => {
    root.querySelector('[data-price]').innerHTML = priceHtml(v)
    const now = root.querySelector('.price__now')
    const plain = [...document.querySelectorAll('[data-price-plain]')]
    const paint = (c) => {
      const [a, b] = money(c).split(',')
      now.innerHTML = `${a}<small>,${b}</small>`
      plain.forEach((el) => (el.textContent = money(c)))
    }
    cancelAnimationFrame(tick)
    const from = shown, t0 = performance.now(), dur = reduced || from === v.p ? 0 : 800
    const step = (t) => {
      const k = dur ? Math.min(1, (t - t0) / dur) : 1
      shown = Math.round(from + (v.p - from) * (1 - Math.pow(2, -10 * k)) / (1 - Math.pow(2, -10)))
      paint(shown)
      if (k < 1) tick = requestAnimationFrame(step)
    }
    step(t0)
  }

  // ---------- Dropdowns ----------
  // Fallback colour dots when the shop has no swatch for a value (Shopify swatches win, see data.swatches).
  const COLORS = { schwarz: '#1d1d1f', weiß: '#f2f2f2', weiss: '#f2f2f2', silber: '#d9d9d9', grau: '#8e8e93', gold: '#e3c79b', rosa: '#f4c9d0', pink: '#f4c9d0', lila: '#c9b3e6', blau: '#5b7fa6', grün: '#7fa88a', gruen: '#7fa88a', rot: '#c8323b', gelb: '#ffe300', orange: '#e2763a', titan: '#b5b0a8' }
  const dot = (i, val) => {
    if (i !== colorIdx) return ''
    const c = data.swatches[val] || COLORS[val.toLowerCase()] || COLORS[val.toLowerCase().split(' ').pop()]
    return c ? `<i class="dd__dot" style="background:${esc(c)}"></i>` : ''
  }

  /** The list for option i: [{val, v (target variant), match (fits the other current options)}] */
  const items = (i) => {
    const values = [...new Set(avail.map((v) => v.o[i]))]
    return values
      .map((val) => {
        const opts = cur.o.slice()
        opts[i] = val
        const exact = pick(opts)
        return { val, v: exact || avail.find((v) => v.o[i] === val), match: !!exact }
      })
      .sort((a, b) => b.match - a.match)
  }

  const dds = [...root.querySelectorAll('.dd')].map((wrap) => {
    const i = Number(wrap.dataset.opt)
    const btn = wrap.querySelector('.dd__btn')
    const list = wrap.querySelector('.dd__list')
    const label = btn.querySelector('span')
    let opts = []
    let active = 0

    const render = () => {
      opts = items(i)
      let group = null
      list.innerHTML = opts
        .map((o, n) => {
          const head = o.match !== group && opts.some((x) => !x.match)
            ? `<li class="dd__group" role="presentation">${esc(o.match ? data.labels.match : data.labels.other)}</li>`
            : ''
          group = o.match
          const d = o.val === cur.o[i] ? 0 : o.v.p - cur.p
          const delta = d ? `<small${d < 0 ? ' data-tone="down"' : ''}>${d > 0 ? '+' : '−'} ${money(Math.abs(d))}</small>` : ''
          return `${head}<li role="option" id="${list.id || (list.id = `dd-${i}`)}-${n}" data-n="${n}" aria-selected="${o.val === cur.o[i]}">${dot(i, o.val)}<span${i === colorIdx ? ' data-capitalize' : ''}>${esc(o.val)}</span>${delta}</li>`
        })
        .join('')
    }
    const paint = () => {
      label.innerHTML = `${dot(i, cur.o[i])}<span${i === colorIdx ? ' data-capitalize' : ''}>${esc(cur.o[i])}</span>`
    }
    const options = () => [...list.querySelectorAll('[role=option]')]
    const highlight = (n) => {
      const all = options()
      active = (n + all.length) % all.length
      all.forEach((li, j) => li.classList.toggle('is-active', j === active))
      list.setAttribute('aria-activedescendant', all[active]?.id || '')
      all[active]?.scrollIntoView({ block: 'nearest' })
    }
    const outside = (e) => !wrap.contains(e.target) && close(false)
    const open = () => {
      dds.forEach((d) => d !== api && d.close(false))
      render()
      list.hidden = false
      wrap.classList.add('is-open')
      btn.setAttribute('aria-expanded', 'true')
      highlight(Math.max(0, opts.findIndex((o) => o.val === cur.o[i])))
      list.focus()
      document.addEventListener('pointerdown', outside)
    }
    const close = (focus = true) => {
      if (list.hidden) return
      list.hidden = true
      wrap.classList.remove('is-open')
      btn.setAttribute('aria-expanded', 'false')
      document.removeEventListener('pointerdown', outside)
      if (focus) btn.focus()
    }
    const choose = (n) => {
      const o = opts[n]
      close()
      if (o && o.v.id !== cur.id) select(o.v)
    }
    btn.addEventListener('click', () => (list.hidden ? open() : close()))
    btn.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return
      e.preventDefault()
      open()
    })
    list.addEventListener('click', (e) => {
      const li = e.target.closest('[role=option]')
      if (li) choose(Number(li.dataset.n))
    })
    list.addEventListener('pointermove', (e) => {
      const li = e.target.closest('[role=option]')
      if (li) highlight(Number(li.dataset.n))
    })
    list.addEventListener('keydown', (e) => {
      const k = e.key
      if (k === 'Tab') return close(false)
      if (k === 'ArrowDown') highlight(active + 1)
      else if (k === 'ArrowUp') highlight(active - 1)
      else if (k === 'Home') highlight(0)
      else if (k === 'End') highlight(-1)
      else if (k === 'Enter' || k === ' ') choose(active)
      else if (k === 'Escape') close()
      else return
      e.preventDefault()
    })
    const api = { paint, close }
    return api
  })

  // ---------- Selecting a variant ----------
  const summary = () => cur.o.join(' · ')

  function swapImage(v) {
    if (!stageImg || !v.img || stageImg.dataset.src === v.img) return
    stageImg.dataset.src = v.img
    const set = () => {
      stageImg.removeAttribute('srcset')
      stageImg.src = v.img
      stageImg.alt = v.alt
    }
    if (barImg) barImg.src = v.img.replace(/width=\d+/, 'width=120')
    if (reduced) return set()
    // The blob "gulps" (the engine's spring gives the rebound) while the device swaps.
    if (blob) {
      blob.dataset.blobScale = '0.86'
      setTimeout(() => (blob.dataset.blobScale = '1'), 260)
    }
    stageImg.animate([{ opacity: 1, translate: '0 0' }, { opacity: 0, translate: '0 8%' }], { duration: 250, easing: 'ease-in' }).onfinish = () => {
      set()
      stageImg.animate([{ opacity: 0, translate: '0 -10%' }, { opacity: 1, translate: '0 0' }], { duration: 900, easing: EASE })
    }
  }

  let partsCtrl = null
  function select(v) {
    cur = v
    idInput.value = v.id
    countPrice(v)
    const sku = root.querySelector('[data-sku]')
    if (sku) {
      sku.hidden = !v.sku
      sku.querySelector('[data-sku-value]').textContent = v.sku || ''
    }
    const tax = root.querySelector('[data-tax-note]')
    if (tax) tax.hidden = !/-differenzbesteuert$/.test(v.url) // the twin's variants are margin-scheme
    bar?.querySelector('[data-summary]') && (bar.querySelector('[data-summary]').textContent = summary())
    dds.forEach((d) => d.paint())
    swapImage(v)
    history.replaceState(null, '', `${v.url}?variant=${v.id}`)
    // Variant-dependent server parts (energy label …), from the variant's own product (a twin has its own URL).
    partsCtrl?.abort()
    partsCtrl = new AbortController()
    fetch(`${v.url}?variant=${v.id}&section_id=${root.dataset.section}`, { signal: partsCtrl.signal })
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html')
        root.querySelectorAll('[data-variant-part]').forEach((el) => {
          const fresh = doc.querySelector(`[data-variant-part="${el.dataset.variantPart}"]`)
          if (fresh) el.replaceWith(fresh)
        })
      })
      .catch(() => {})
  }

  // SKU: a click copies it (the team needs it often); a short "kopiert" as feedback
  root.querySelector('[data-sku]')?.addEventListener('click', async (e) => {
    const btn = e.currentTarget
    const value = btn.querySelector('[data-sku-value]').textContent.trim()
    try {
      await navigator.clipboard.writeText(value)
      btn.dataset.copied = ''
      setTimeout(() => delete btn.dataset.copied, 1400)
    } catch {}
  })

  // ---------- Delivery date (in the browser, so a cached page is never stale) ----------
  // Order by 14:30 (Berlin time). Mon–Thu: before → tomorrow d+1–d+2, after → day after d+2–d+3.
  // Fri: before → d+1–d+3, after → d+1–d+4. Sat: d+2–d+4. Sun: d+2–d+3. (Rules of the old theme.)
  const delivery = root.querySelector('[data-delivery]')
  if (delivery && /^de/.test(html.lang)) {
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }))
    const early = now.getHours() * 100 + now.getMinutes() < 1430
    const day = now.getDay()
    const [from, to, word] =
      day >= 1 && day <= 4 ? (early ? [1, 2, 'tomorrow'] : [2, 3, 'day_after'])
      : day === 5 ? (early ? [1, 3, 'tomorrow'] : [1, 4, 'tomorrow'])
      : day === 6 ? [2, 4, 'day_after']
      : [2, 3, 'day_after']
    // "morgen – Fr, 10.10.": the first day as a word, the last one as weekday + date
    const fmt = (d) => new Date(now.getTime() + d * 864e5).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' })
    delivery.querySelector('[data-delivery-date]').textContent = `${data.labels[word].toLowerCase()} – ${fmt(to)}`
    delivery.hidden = false
  }

  // ---------- Energy label / data sheet in a dialog ----------
  const doc = document.getElementById('DocDialog')
  const frame = doc?.querySelector('iframe')
  // Google Drive links only embed as /preview
  const embeddable = (url) => {
    try {
      const u = new URL(url, location.href)
      if (u.hostname.includes('drive.google.com')) {
        const id = u.pathname.match(/\/file\/d\/([^/]+)/)?.[1] || u.searchParams.get('id')
        if (id) return `https://drive.google.com/file/d/${id}/preview`
      }
      return u.href
    } catch {
      return url
    }
  }
  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-doc]')
    if (!a || !doc) return
    e.preventDefault()
    doc.querySelector('#DocTitle').textContent = a.dataset.doc
    doc.querySelector('[data-doc-ext]').href = a.href
    frame.title = a.dataset.doc
    frame.src = embeddable(a.href)
    doc.showModal()
    window.janado?.lenis?.stop()
  })
  doc?.addEventListener('click', (e) => (e.target === doc || e.target.closest('[data-doc-close]')) && doc.close())
  doc?.addEventListener('close', () => {
    frame.src = 'about:blank'
    window.janado?.lenis?.start()
  })

  // ---------- Add to cart: a blob drips off the product and arcs into the cart, then the drawer opens ----------
  function fly(from) {
    const cart = document.querySelector('[data-cart-open]')
    if (reduced || !from || !cart) return Promise.resolve()
    const a = from.getBoundingClientRect()
    const b = cart.getBoundingClientRect()
    const x = document.createElement('span')
    const y = document.createElement('span')
    x.className = 'fly-x'
    y.className = 'fly'
    y.dataset.blob = `fly-${Date.now()}`
    x.append(y)
    x.style.translate = `${a.left + a.width / 2}px ${a.top + a.height / 2}px`
    document.body.append(x)
    const dx = b.left + b.width / 2 - (a.left + a.width / 2)
    const dy = b.top + b.height / 2 - (a.top + a.height / 2)
    // x eases in and out, y falls in with a little back-swing: together an arc
    x.animate([{ transform: 'none' }, { transform: `translateX(${dx}px)` }], { duration: 900, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', fill: 'forwards' })
    const anim = y.animate(
      [
        { transform: 'translateY(0) scale(0.4)' },
        { transform: 'translateY(0) scale(1.1)', offset: 0.25 },
        { transform: `translateY(${dy}px) scale(0.4)` },
      ],
      { duration: 900, easing: 'cubic-bezier(0.6, -0.28, 0.74, 0.05)', fill: 'forwards' }
    )
    return anim.finished.then(() => x.remove())
  }

  async function add(from) {
    const cart = window.janado?.cart
    if (!cart) return form.submit()
    const [, ok] = await Promise.all([fly(from), cart.add(cur.id)])
    if (ok) cart.open()
  }
  form?.addEventListener('submit', (e) => {
    e.preventDefault()
    add(stageImg)
  })
  bar?.querySelector('[data-add-bar]').addEventListener('click', () => add(bar.querySelector('.buybar__thumb')))

  // ---------- Floating buy bar: appears once the main button has scrolled out above ----------
  const buy = root.querySelector('[data-buy]')
  if (bar && buy) {
    // On every scroll, not an IntersectionObserver: a jump past the button (fast fling, anchor) never crosses it.
    let ticking = false
    const update = () => {
      ticking = false
      const on = buy.getBoundingClientRect().bottom < 90 // gone under the header
      bar.classList.toggle('is-on', on)
      bar.inert = !on
    }
    addEventListener('scroll', () => ticking || ((ticking = true), requestAnimationFrame(update)), { passive: true })
    update()
  }

  // ---------- Sheets (condition, slides in from the right like the cart) and the legal guarantee dialog ----------
  const slideIn = (d) => {
    d.showModal()
    window.janado?.lenis?.stop()
    if (!reduced) d.animate([{ transform: 'translateX(100%)' }, { transform: 'none' }], { duration: 800, easing: EASE })
  }
  const slideOut = (d) => {
    if (!d.open) return
    if (reduced) return d.close()
    d.animate([{ transform: 'none' }, { transform: 'translateX(100%)' }], { duration: 450, easing: 'cubic-bezier(0.5, 0, 0.75, 0)' }).onfinish = () => d.close()
  }

  // Condition sheet: only the conditions this product offers, each with its price difference; tapping one selects it.
  const sheet = document.getElementById('CondSheet')
  if (sheet && condIdx >= 0) {
    const fill = () => {
      for (const li of sheet.querySelectorAll('[data-cond]')) {
        const c = li.dataset.cond
        const opts = cur.o.slice()
        const val = [...new Set(avail.map((v) => v.o[condIdx]))].find((x) => x.toLowerCase() === c)
        li.hidden = !val
        if (!val) continue
        opts[condIdx] = val
        const target = pick(opts) || avail.find((v) => v.o[condIdx] === val)
        li.target = target
        const mine = val === cur.o[condIdx]
        const btn = li.querySelector('.cond')
        btn.setAttribute('aria-current', String(mine))
        const d = target.p - cur.p
        const el = li.querySelector('[data-cond-delta]')
        el.textContent = mine ? data.labels.your_choice : d ? `${d > 0 ? '+' : '−'} ${money(Math.abs(d))}` : ''
        el.dataset.tone = !mine && d < 0 ? 'down' : ''
        const photo = li.querySelector('[data-cond-photo]')
        if (cur.img) photo.src = cur.img.replace(/width=\d+/, 'width=120')
      }
    }
    root.addEventListener('click', (e) => {
      if (!e.target.closest('[data-cond-open]')) return
      fill()
      slideIn(sheet)
    })
    sheet.addEventListener('click', (e) => {
      if (e.target === sheet || e.target.closest('[data-cond-close]')) return slideOut(sheet)
      const li = e.target.closest('[data-cond]')
      if (!li?.target) return
      if (li.target.id !== cur.id) select(li.target)
      slideOut(sheet)
    })
    sheet.addEventListener('cancel', (e) => {
      e.preventDefault()
      slideOut(sheet)
    })
    sheet.addEventListener('close', () => window.janado?.lenis?.start())
  }

  // Trust seal on the photo (snippets/seal) opens "Unser Versprechen".
  const seal = root.querySelector('[data-seal-open]')
  const sealSheet = document.getElementById('SealSheet')
  if (seal && sealSheet) {
    seal.addEventListener('click', () => slideIn(sealSheet))
    sealSheet.addEventListener('click', (e) => (e.target === sealSheet || e.target.closest('[data-seal-close]')) && slideOut(sealSheet))
    sealSheet.addEventListener('cancel', (e) => {
      e.preventDefault()
      slideOut(sealSheet)
    })
    sealSheet.addEventListener('close', () => window.janado?.lenis?.start())
  }

  // "gut zu wissen." tiles open their text in a sheet; arrows step to the previous / next topic.
  const more = document.getElementById('MoreSheet')
  if (more) {
    const panels = [...more.querySelectorAll('[data-more-panel]')]
    const title = more.querySelector('#MoreSheetTitle')
    const steps = [...more.querySelectorAll('[data-more-step]')]
    let at = 0
    const show = (i, fade) => {
      at = i
      panels.forEach((p, j) => (p.hidden = j !== i))
      title.textContent = panels[i].dataset.title
      steps.forEach((b) => {
        const k = i + Number(b.dataset.moreStep)
        b.hidden = !panels[k]
        if (panels[k]) b.querySelector('[data-more-label]').textContent = panels[k].dataset.title
      })
      more.scrollTop = 0
      if (fade && !reduced) [title, panels[i]].forEach((el) => el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: EASE }))
    }
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-more]')
      if (!t) return
      show(panels.findIndex((p) => p.dataset.morePanel === t.dataset.more))
      slideIn(more)
    })
    more.addEventListener('click', (e) => {
      if (e.target === more || e.target.closest('[data-more-close]')) return slideOut(more)
      const b = e.target.closest('[data-more-step]')
      if (b) show(at + Number(b.dataset.moreStep), true)
    })
    more.addEventListener('cancel', (e) => {
      e.preventDefault()
      slideOut(more)
    })
    more.addEventListener('close', () => window.janado?.lenis?.start())
  }

  // "im direkten vergleich.": numbers out of the shop's free text ("Li-Ionen 2.438 mAh", "6,1 Zoll / 15,494 cm"),
  // bars relative to the largest value, the best one marked; bars grow once the table is in view. Phones: pills.
  const vs = root.querySelector('[data-vs]')
  if (vs) {
    const grid = vs.querySelector('.vs')
    const de = (t) => parseFloat(t.replace(/\.(?=\d{3}\b)/g, '').replace(',', '.'))
    for (const row of grid.querySelectorAll('[data-unit]')) {
      const unit = row.dataset.unit
      const re = new RegExp(`(\\d[\\d.,]*)\\s*${unit}\\b`, 'i')
      const cells = [...row.querySelectorAll('.vs__cell')].map((c) => {
        const m = re.exec(c.textContent)
        return { c, v: m ? de(m[1]) : NaN }
      })
      const ok = cells.filter((x) => x.v > 0)
      if (ok.length < 2) continue
      const max = Math.max(...ok.map((x) => x.v))
      const best = row.dataset.better === 'high' ? max : row.dataset.better === 'low' ? Math.min(...ok.map((x) => x.v)) : null
      for (const { c, v } of ok) {
        c.querySelector('.vs__val').textContent = `${(reduced ? v : 0).toLocaleString('de-DE')} ${unit}` // counts up in view
        c.querySelector('.vs__val').dataset.v = v
        if (v === best && ok.filter((x) => x.v === best).length < ok.length) c.querySelector('.vs__val').insertAdjacentHTML('beforeend', '<span class="vs__best" title="Bester Wert"></span>')
        c.insertAdjacentHTML('beforeend', `<span class="vs__bar" aria-hidden="true"><i style="--w: ${(v / max).toFixed(3)}"></i></span>`)
      }
    }
    // each row grows its bars (and counts its numbers up) when it comes into view
    const count = (row) => {
      if (reduced) return
      for (const val of row.querySelectorAll('.vs__val[data-v]')) {
        const v = Number(val.dataset.v), dec = v % 1 ? 1 : 0, t0 = performance.now(), txt = val.firstChild
        const step = (t) => {
          const k = Math.min(1, (t - t0) / 1100), e = 1 - Math.pow(1 - k, 3)
          txt.textContent = `${(v * e).toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec })} ${row.dataset.unit}`
          if (k < 1) requestAnimationFrame(step)
        }
        requestAnimationFrame(step)
      }
    }
    const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (e.target.classList.add('is-in'), count(e.target), io.unobserve(e.target))), { threshold: 0.6 })
    grid.querySelectorAll('[data-unit]').forEach((r) => io.observe(r))
    vs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-vs-pick]')
      if (!b) return
      grid.dataset.active = b.dataset.vsPick
      vs.querySelectorAll('[data-vs-pick]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)))
    })
  }

  const lg = document.getElementById('LegalGuarantee')
  root.addEventListener('click', (e) => e.target.closest('[data-lg-open]') && lg?.showModal())
  lg?.addEventListener('click', (e) => (e.target === lg || e.target.closest('[data-lg-close]')) && lg.close())

  // ---------- Cross-sell: one tap adds the accessory, its blob flies to the cart; the drawer stays closed ----------
  root.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-xs]')
    if (!b || b.getAttribute('aria-pressed') === 'true' || !window.janado?.cart) return
    b.setAttribute('aria-pressed', 'true')
    const [, ok] = await Promise.all([fly(b.closest('.xs').querySelector('.xs__img')), window.janado.cart.add(b.dataset.xs)])
    if (ok) b.textContent = data.labels.added
    else b.setAttribute('aria-pressed', 'false')
  })

  // ---------- Charger switch: adds the charger with _added_via=charger_optin, switching off removes that line ----------
  const charger = root.querySelector('[data-charger]')
  if (charger) { // window.janado.cart (cart-drawer.js) loads after this module, so it is looked up on use
    const box = charger.querySelector('input')
    const optinLine = async () => {
      const c = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json())
      return c.items.find((i) => String(i.variant_id) === charger.dataset.charger && i.properties?._added_via === 'charger_optin')
    }
    const show = (on) => {
      box.checked = on
      charger.querySelector('[data-charger-on]').hidden = !on
      charger.querySelector('[data-charger-off]').hidden = on
    }
    optinLine().then((l) => show(!!l)).catch(() => {})
    box.addEventListener('change', async () => {
      if (!window.janado?.cart) return show(false)
      box.disabled = true
      if (box.checked) {
        const [, ok] = await Promise.all([fly(charger.querySelector('.charger__icon')), window.janado.cart.add(charger.dataset.charger, 1, { _added_via: 'charger_optin' })])
        show(!!ok)
        if (ok && !reduced) charger.animate([{ scale: 1 }, { scale: 1.03 }, { scale: 1 }], { duration: 450, easing: 'cubic-bezier(0.3, 1.6, 0.5, 1)' })
      } else {
        const line = await optinLine()
        if (line) await window.janado.cart.change(line.key, 0)
        show(false)
      }
      box.disabled = false
    })
  }

  // initial state (the server rendered the URL's variant; the cheaper twin may have won)
  if (cur.id !== data.current) select(cur)
  else {
    dds.forEach((d) => d.paint())
    if (bar) bar.querySelector('[data-summary]').textContent = summary()
  }
}
